var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("b-card", { attrs: { title: "Filtros" } }, [
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "col-4" },
        [
          _c("PeriodFilter", {
            attrs: { customWidth: "w-28" },
            on: { changePeriod: _vm.onPeriodChange }
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "col-4" },
        [
          _c("vs-input", {
            staticClass: "w-100",
            attrs: { label: "Rut", placeholder: "Escriba un rut para buscar" },
            nativeOn: {
              keyup: function($event) {
                return _vm.checkFilter($event)
              }
            },
            model: {
              value: _vm.client,
              callback: function($$v) {
                _vm.client = typeof $$v === "string" ? $$v.trim() : $$v
              },
              expression: "client"
            }
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "col-4" },
        [
          _c(
            "vs-select",
            {
              staticClass: "w-100",
              attrs: {
                autocomplete: "",
                label: "Razón social",
                placeholder: "Escriba la razón social"
              },
              on: {
                change: function($event) {
                  return _vm.setFilter("razonSocial", _vm.businessName)
                }
              },
              model: {
                value: _vm.businessName,
                callback: function($$v) {
                  _vm.businessName = $$v
                },
                expression: "businessName"
              }
            },
            [
              _c("vs-select-item", { attrs: { value: "*", text: "Todo" } }),
              _vm._l(_vm.transaccionality, function(item) {
                return _c("vs-select-item", {
                  key: item.iut,
                  attrs: {
                    autocomplete: "",
                    value: "iut:" + item.iut,
                    text: item.razonSocial
                  }
                })
              })
            ],
            2
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }